'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'traffic-light-stop';
var width = 320;
var height = 512;
var aliases = [];
var unicode = 'f63a';
var svgPathData = ['M16 32l0 352c0 79.5 64.5 144 144 144s144-64.5 144-144l0-352c0-26.5-21.5-48-48-48L64-16C37.5-16 16 5.5 16 32zm200 80a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm0 144a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM104 400c0-30.9 25.1-56 56-56s56 25.1 56 56-25.1 56-56 56-56-25.1-56-56z', 'M256-16c26.5 0 48 21.5 48 48l0 352c0 79.5-64.5 144-144 144S16 463.5 16 384L16 32C16 5.5 37.5-16 64-16l192 0zM64-32C28.7-32 0-3.3 0 32L0 384c0 88.4 71.6 160 160 160s160-71.6 160-160l0-352c0-35.3-28.7-64-64-64L64-32zm96 392c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0-16c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56zm40-88a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm-96 0a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56-104a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm0-96a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0 40a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTrafficLightStop = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;